export default __webpack_public_path__ + "static/media/Doribac-100-ml-ban.4ea84f80.jpg";